(() => {
  const successDialog = /** @type {HTMLDialogElement | null} */ (
    document.getElementById('vv-contact-success-modal')
  );
  if (!successDialog) return;

  const SUCCESS_HASH = '#vv-contact-success';

  /** @type {number} */
  let previousScrollY = 0;

  const isLocalThemeDev = () => {
    const host = window.location.hostname;
    return host === '127.0.0.1' || host === 'localhost';
  };

  const unlockScroll = () => {
    document.body.style.width = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.documentElement.classList.remove('vv-signup-modal-open');
    window.scrollTo({ top: previousScrollY, behavior: 'instant' });
  };

  const openSuccessModal = () => {
    if (successDialog.open) return;

    previousScrollY = window.scrollY;

    requestAnimationFrame(() => {
      document.body.style.width = '100%';
      document.body.style.position = 'fixed';
      document.body.style.top = `-${previousScrollY}px`;
      document.documentElement.classList.add('vv-signup-modal-open');
      successDialog.showModal();
    });
  };

  const closeSuccessModal = () => {
    if (!successDialog.open) return;
    successDialog.close();
    unlockScroll();
  };

  const cleanSuccessFromUrl = () => {
    const params = new URLSearchParams(window.location.search);
    params.delete('contact_posted');

    const query = params.toString();
    const nextUrl = `${window.location.pathname}${query ? `?${query}` : ''}`;
    window.history.replaceState({}, '', nextUrl);
  };

  successDialog.addEventListener('click', (event) => {
    if (event.target === successDialog) closeSuccessModal();
  });

  successDialog.addEventListener('cancel', (event) => {
    event.preventDefault();
    closeSuccessModal();
  });

  successDialog.addEventListener('close', () => {
    if (document.documentElement.classList.contains('vv-signup-modal-open')) {
      unlockScroll();
    }
  });

  document.querySelectorAll('[data-vv-contact-close]').forEach((button) => {
    button.addEventListener('click', closeSuccessModal);
  });

  document.querySelectorAll('.vv-contact-main__form').forEach((form) => {
    if (!(form instanceof HTMLFormElement)) return;

    form.addEventListener('submit', () => {
      const subject = form.querySelector('[data-vv-contact-subject]')?.value?.trim();
      const message = form.querySelector('[data-vv-contact-message]')?.value?.trim();
      const bodyField = form.querySelector('[data-vv-contact-message]');
      if (!bodyField || !message) return;

      if (subject) {
        bodyField.value = `Subject: ${subject}\n\n${message}`;
      }
    });
  });

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!form.classList.contains('vv-contact-main__form')) return;
      if (!isLocalThemeDev()) return;

      event.preventDefault();

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      openSuccessModal();
    },
    true
  );

  const params = new URLSearchParams(window.location.search);
  const hasContactPostedParam = params.has('contact_posted');
  const hasSuccessHash = window.location.hash === SUCCESS_HASH;
  const hasLiquidSuccessFlag = document.querySelector('[data-vv-contact-success]');

  if (!hasContactPostedParam && !hasSuccessHash && !hasLiquidSuccessFlag) return;

  openSuccessModal();
  cleanSuccessFromUrl();
})();
